import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Havana Daily · Your Source for Local News</p>
        <h1>Stay Informed with Havana Daily</h1>
        <p className="lede">
          Discover the latest news, events, and stories that matter to you. Havana Daily brings you
          comprehensive coverage of local happenings, insightful articles, and engaging community content.
        </p>
        <div className="cta-row">
          <a href="/subscribe" target="_blank">
            Subscribe Now
          </a>
          <a href="/about" target="_blank" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Breaking News</h2>
          <p>
            Stay updated with real-time news alerts and in-depth reporting on the issues that impact your community.
          </p>
        </article>
        <article>
          <h2>Community Events</h2>
          <p>
            Explore upcoming events, activities, and gatherings happening in Havana. Join us in celebrating our vibrant community.
          </p>
        </article>
        <article>
          <h2>Opinion & Insights</h2>
          <p>
            Read thought-provoking articles and opinion pieces from local writers and experts. Share your voice with us!
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;